const config = {
  apiUrl: process.env.REACT_APP_API_URL,

  instaToken: process.env.REACT_APP_INSTA_TOKEN,

  joiOptions: {
    abortEarly: false,
    allowUnknown: true,
    errors: {
      wrap: {
        label: "",
      },
    },
  },

  fileValidation: {
    imageTypes: ["image/jpeg", "image/png", "image/webp", "image/svg+xml"],

    documentTypes: [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],

    documentExtensions: [".pdf", ".doc", ".docx"],

    defaultMaxSizeMB: 5,
  },
};

export default config;
